import { useQuery } from '@tanstack/vue-query';

type DeveloperLogosResponse = {
  success: boolean;
  data: Record<string, string>;
};

export const useDeveloperLogosQuery = () => {
  const authStore = useAuthStore();

  return useQuery({
    queryKey: ['developer-logos'],
    queryFn: () =>
      $fetch<DeveloperLogosResponse>('/api/developers/logos', {
        headers: { Authorization: `Bearer ${authStore.token}` },
      }).then((r) => r.data),
    enabled: computed(() => !!authStore.token),
    staleTime: 10 * 60 * 1000,
  });
};
